module.exports = __webpack_public_path__ + "img/JSBS.7a20fe9d.jpg";